import { render, staticRenderFns } from "./shipmentRequestAdd.vue?vue&type=template&id=bdb9cae0&scoped=true&"
import script from "./shipmentRequestAdd.vue?vue&type=script&lang=js&"
export * from "./shipmentRequestAdd.vue?vue&type=script&lang=js&"
import style0 from "./shipmentRequestAdd.vue?vue&type=style&index=0&id=bdb9cae0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb9cae0",
  null
  
)

export default component.exports